import { render } from "./salary-settings.vue?vue&type=template&id=41c54246"
import script from "./salary-settings.vue?vue&type=script&lang=js"
export * from "./salary-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__